module.exports = __webpack_public_path__ + "static/img/girl.21b2144.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bathroom/girl.svg
// module id = 148
// module chunks = 2